/**
 * Theme applied when the user has never saved a preference (`users.theme` is null),
 * for `ThemeProvider` default before `/me` loads, and for Settings “restore defaults”.
 * Backend stores unset preference as `NULL`; keep this aligned with product default.
 */
export const DEFAULT_APP_THEME = "light" as const

/** Overlapping project team avatars before +N overflow (project detail header + dashboard table strip). */
export const PROJECT_TEAM_AVATARS_MAX_VISIBLE = 5

/**
 * Page width caps. Single source of truth — import these instead of writing `max-w-[…]` in a page,
 * and compose with `cn()`. The page background stays full-bleed; only the content column is capped.
 *
 * - `LIST_MAX_WIDTH_CLASS` — standalone list/table pages (dashboard). Pages inside the Settings
 *   shell fill their pane instead, so they don't use this.
 * - `CONTENT_MAX_WIDTH_CLASS` — the wide app pages (project summary, selection sheet), a step wider.
 */
export const LIST_MAX_WIDTH_CLASS = "max-w-[1400px]"
export const CONTENT_MAX_WIDTH_CLASS = "max-w-[1600px]"

/** Account display-name cap — keep in sync with `AccountUpdate.name` in `app/models/account.py`. */
export const ACCOUNT_NAME_MAX_LENGTH = 100
